import { useTranslation } from "react-i18next";
import i18n from "locales/i18n";

import PageWrapper from "components/page/PageWrapper";
import UpperPart from "./UpperPart";
import Steps from "./Steps";

import bg from 'assets/images/banner/banner02.jpg';

import pcKo from 'assets/images/solutions/business/ko/develop_1_pc.png';
import mobileKo from 'assets/images/solutions/business/ko/develop_1_mobile.jpg';
import pcEn from 'assets/images/solutions/business/en/develop_1_pc.png';
import mobileEn from 'assets/images/solutions/business/en/develop_1_mobile.jpg';


export default function Business(){
  const {t} = useTranslation();
  const locale = i18n.language?? 'ko';
  const menuName= t('menu.sub-business');
  const path=[
    {url:'/solutions', name:t('menu.main-solutions')},
    {url:'/solutions/solar', name:t('menu.sub-business')}];
  const title = t('business.banner.title');
  const comment = t('business.banner.comment');
  
  const imgs={
    ko:{mobile:mobileKo, pc:pcKo},
    en:{mobile:mobileEn, pc:pcEn}
  }

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex flex-col items-center">
        <div className="flex flex-col px-mobile lg:w-[1200px]">
          <UpperPart index={1}/>
          <UpperPart index={2} reverse="true"/>
        </div>
        <Steps/>
        <div className="lg:w-[1200px] flex flex-col items-center p-10 lg:mt-20">
          <picture className="max-w-[80%] mb-10 lg:mb-0">
            <source media="(min-width: 1024px)" srcSet={imgs[locale].pc}/>
            <img className="" src={imgs[locale].mobile} alt='development business concept'/>
          </picture>
          <div className="p-4 border border-gray-300 lg:mt-10 lg:p-10">
            <p className="w-full mb-10 text-center text-blue-500">{t('business.sales.title')}</p>
            {[1, 2, 3, 4].map(i=> {
              return (
                <p key={i} className={`my-2 text-gray-500 ${i===4? "mt-5":""}`}>{t(`business.sales.comment-${i}`)}</p>
              );  
            })}
          </div>
        </div>
        <div className="flex flex-col justify-center p-10 items-center lg:w-[1200px] lg:my-20">
          <p className="text-3xl lg:text-4xl lg:mb-20">{t('business.type.title')}</p>
          <div className="flex flex-col my-5 lg:flex-row lg:items-center">
            <div className="my-5 text-gray-500 text-base/8 lg:mr-10">
              <p className="mb-10"><span className="text-3xl text-[#2c85cc]">{t('business.type.first')}</span>{t('business.type.comment-1')}</p>
              <p>{t('business.type.comment-2')}</p>
            </div>
            <img src={require(`assets/images/solutions/business/${locale}/develop_2.png`)} 
            alt='development concept' className="lg:w-[528px] lg:h-[322px]"/>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
